import { MediaThumb } from "~/shared/ui/media-thumb";
import type { Asset } from "../types";

interface AssetThumbProps {
    asset: Asset;
    className?: string;
}

/** Превью ассета — тонкая обёртка над shared `MediaThumb` (постер видео через `#t=0.1`). */
export function AssetThumb({ asset, className }: AssetThumbProps) {
    return <MediaThumb url={asset.previewUrl} kind={asset.type} className={className} />;
}
